import ElectronicReceiptsContainer from './ElectronicReceipts'
export default ElectronicReceiptsContainer
